import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "app-timer" };
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppTimer',
    props: {
        milliseconds: {
            type: Number,
            default: 0,
            required: true,
        },
    },
    emits: ['update:milliseconds', 'get-time', 'has-expired'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const timer = ref(props.milliseconds);
        const timerToSeconds = computed(() => timer.value / 1000);
        const timerId = ref(null);
        const hasExpired = ref(false);
        watch(() => props.milliseconds, newVal => {
            hasExpired.value = false;
            timer.value = newVal;
            stopTimer();
            startTimer();
        });
        watch(() => timer.value, newVal => {
            if (newVal <= 0 && !hasExpired.value) {
                timer.value = 0;
                hasExpired.value = true;
                emits('has-expired');
            }
            emits('update:milliseconds', timer.value);
            emits('get-time', timer.value);
        });
        const formattedTime = computed(() => {
            const hours = Math.floor(timerToSeconds.value / 3600);
            const minutes = Math.floor((timerToSeconds.value % 3600) / 60);
            const seconds = Math.floor(timerToSeconds.value % 60);
            const secondsString = String(seconds).padStart(2, '0');
            if (hours > 0)
                return `${hours}:${minutes}:${secondsString}`;
            return `${minutes}:${secondsString}`;
        });
        const startTimer = () => {
            if (timerId.value)
                return;
            timerId.value = window.setInterval(() => {
                timer.value = Math.max(timer.value - 1000, 0);
                if (timer.value === 0) {
                    stopTimer();
                }
            }, 1000);
        };
        const stopTimer = () => {
            if (timerId.value !== null) {
                clearInterval(timerId.value);
                timerId.value = null;
            }
        };
        onMounted(() => {
            startTimer();
            emits('update:milliseconds', timer.value);
        });
        onBeforeUnmount(() => {
            stopTimer();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(formattedTime.value), 1 /* TEXT */));
        };
    }
});
